import type { Company } from '@gokrew/models/company';

type NamedCompany = Partial<Pick<Company, 'legalName' | 'abbreviatedName'>>;

/**
 * The name to show a company by, everywhere in the UI: its abbreviated name,
 * falling back to the legal name only when no abbreviation is set. The legal
 * name itself is only shown where it is entered or edited.
 */
export const companyDisplayName = (
  company: NamedCompany | null | undefined
): string =>
  company?.abbreviatedName?.trim() || company?.legalName?.trim() || '';

/**
 * A name placed right before a sentence's closing period ("... for Acme
 * Inc.") loses its own trailing period, so the sentence never ends in "..".
 */
export const withoutTrailingPeriod = (name: string): string =>
  name.trim().replace(/\.+$/, '');
